import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  cancelFunction: PropTypes.func.isRequired,
  successFunction: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const UserResendInvite = ({ cancelFunction, successFunction, user }) => (
  <div>
    <p>You are about to resend an invitation link to {user.email}.</p>
    <p>
      Make sure to let {user.firstName} {user.lastName} know to check their e-mail.
    </p>
    <div className="modal-footer">
      <button
        type="button"
        className="btn btn-secondary"
        data-dismiss="modal"
        onClick={cancelFunction}
      >
        Cancel
      </button>
      <button type="button" className="btn btn-primary" onClick={successFunction}>
        Send
      </button>
    </div>
  </div>
);

UserResendInvite.propTypes = propTypes;

export default UserResendInvite;
